// import { useParams } from "react-router-dom"
import PersonalDefaultPage from "./PersonalDefaultPage"
import dollar from "../../images/dollar.svg";
import pig from "../../images/pig.svg";
import agreeGreen from "../../images/agreeGreen.svg";
import { IconInfoBigBlock } from "../../components/blocks/IconInfoBigBlock";
import { color_grey_dark, color_grey_light, color_grey_ultra_light, color_red_default, color_white } from "../../constants/colors";
import { StudentSchedule } from "../../components/blocks/StudentSchedule";
import { StudentLessonsProgram } from "../../components/blocks/StudentLessonsProgram";
import { StudentInfo } from "../../components/blocks/studentProfile/studentInfo/StudentInfo";
import {
    useDispatch,
    useSelector
} from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Config from "../../Config";
import { resetStudent, updateStudent } from "../../store/StudentSlice";
import { LoadingContainer } from "../../components/containers/LoadingContainer";
import { ModalDefault } from "../../components/containers/ModalDefault";
import modal from "../../components/blocks/Modal";
import { BsX } from "react-icons/bs";
import {
    OnestBoldDefault,
    OnestNormalDefault,
    OnestNormalSmall
} from "../../components/styled/TextComponents";
import { ButtonDefault } from "../../components/controls/Button/ButtonDefault";
import config from "../../Config";
import { addZeroToTime, weekDayToFullWeekName } from "./JournalPage";
import React from "react";
import moment from "moment-timezone";
import { useWindowDimensions } from "../../utils";
import { get_user } from "../../components/blocks/profileUpdating/dataUpdating/ProfileDataUpdatingBlock";
import { setUser } from "../../store/UserSlice";
import generateLessonsSchedule from "../../utilities/generateLessonsSchedule";
import {
    getPaidLessonsCount,
    isValidMoneyValue,
    normalizeMoneyInput,
} from "../../utilities/studentMoneyUtils";
import ModalQuestionTwoAnswers from "../../components/blocks/ModalQuestionTwoAnswers";
import { useI18n } from "../../i18n/I18nProvider";

import { v4 as uuidv4 } from 'uuid';

const TABLET_WINDOW_WIDTH = 1155; // Задайте ширину окна для планшетов
const WIDE_DESKTOP_WIDTH = 1700;

export const StudentPage = () => {
    const { t } = useI18n();
    const { height: screenHeight, width: screenWidth } = useWindowDimensions();
    const isDesktop = screenWidth > TABLET_WINDOW_WIDTH;
    const isWideDesktop = screenWidth >= WIDE_DESKTOP_WIDTH;
    const isMobileLandscape = screenWidth > screenHeight && screenWidth <= TABLET_WINDOW_WIDTH;
    const mobileContentWidth = isMobileLandscape ? Math.min(600, screenWidth - 30) : Math.min(330, screenWidth - 30);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector(state => state.user)
    const timeZone = user.time_zone || Intl.DateTimeFormat().resolvedOptions().timeZone; // Замените на ваш часовой пояс по умолчанию 

    const gDate = moment(); // Текущее время
    console.warn("gDate SchedulePage", gDate.format())
    const formattedDate = gDate.tz(timeZone); // Преобразование даты в нужный часовой пояс



    const { studentId } = useParams();
    const student = useSelector(state => state.student);
    const [isLoading, setIsLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [changeData, setChangeData] = useState({});
    const [levels, setLevels] = useState([]);
    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);
    const [isShowModalToCloseLesson, setIsShowModalToCloseLesson] = useState('');

    useEffect(() => {

        if (studentId === "new") {
            dispatch(resetStudent({
                studentId: -1,
                image: process.env.PUBLIC_URL + "/no_student_icon.png",
            }));
            setIsLoading(false)
        } else {
            dispatch(resetStudent({
                studentId: Number(studentId) || studentId,
                image: process.env.PUBLIC_URL + "/no_student_icon.png",
            }));

            axios.get(Config.BACKEND_ADDR + `/students/${studentId}`)
                .then((res) => {
                    let downloadedData = res.data
                    dispatch(updateStudent({
                        "studentId": downloadedData.id,
                        "lessonPrice": downloadedData.lesson_cost,
                        "balance": downloadedData.balance,
                        "age": downloadedData.age,
                        "image": downloadedData.image ? Config.CLOUD_ADDR + "/" + downloadedData.image : process.env.PUBLIC_URL + "/no_student_icon.png",
                        "payedLessons": getPaidLessonsCount(
                            downloadedData.balance,
                            downloadedData.lesson_cost,
                        ),
                        "name": downloadedData.name,
                        "englishLevel": downloadedData.english_skill,
                        "additionalInfo": downloadedData.comment,
                        "numberWeeks": downloadedData.numberweeks,
                        "startday": downloadedData.startday,

                    }))
                    setIsLoading(false)

                    axios.get(Config.BACKEND_ADDR + `/lessons/`)
                        .then(lessonsRes => {

                            let newLessonsSchedule = generateLessonsSchedule(lessonsRes.data, downloadedData, timeZone);

                            dispatch(updateStudent({
                                "lessonsSchedule": newLessonsSchedule
                            }))

                        })


                })
        }

    }, [user])

    useEffect(() => {
        axios.get(Config.BACKEND_ADDR + `/levels/`)
            .then(levelRes => {
                setLevels(levelRes.data)
            })
            .catch(err => {
                console.warn("Error fetching levels:", err);
            });

    }, [])


    useEffect(() => {
        (async () => {
            console.log("navbaruser ", user)
            if (!user || Object.keys(user).length === 0) {
                try {
                    const data = await get_user();
                    dispatch(setUser(data));

                } catch (error) {
                    console.error('Error fetching user data:', error);
                    // Обработка ошибки, например, перенаправление на страницу входа
                    //navigate('/auth/login');
                }
            }
        })();
    }, [dispatch, user])


    useEffect(() => {
        let backendAddr = Config.BACKEND_ADDR + "/payments/getSubscriptionPeriod" // /api
        axios.get(backendAddr).then(response => {
            if (response.status === 200) {

                if (response.data.status === "not_paid") {
                    navigate("/billing/");
                }
            }
        }).catch(err => {
            console.warn("Ошибка проверки подписки в БД! ", err)
        })
    }, [navigate]);

    const openInNewWindow = useCallback(async (url) => {
        let uuid = await localStorage.getItem("uid")
        if (!uuid) {
            uuid = uuidv4()
            await localStorage.setItem("uid", uuid)
        }
        let canOpen = await axios.get(Config.BACKEND_ADDR + "/devices/is_open_lesson/" + uuid);
        if (canOpen.status !== 200) {
            console.warn("Lesson opening not allowed");
            return;
        }
        if (canOpen.data && canOpen.data.is_open_lesson === true) {
            const win = window.open(url, "_blank", "noopener,noreferrer");
            if (win) win.opener = null;
        } else {
            setIsShowModalToCloseLesson(url);
        }

    }, []);
    /* 
        useEffect(() => {
           if (levels.length > 0 && student.englishLevel) {
                    let lessonsProgram = levels.filter(level => +level.name === +student.englishLevel)?.[0]
                    if (!lessonsProgram || typeof lessonsProgram.materials !== 'object') {
                        return
                    }
                    let newLessons = [...lessonsProgram?.materials]
                    if (typeof newLessons === 'object') {
                        newLessons?.sort((a, b) => a.index - b.index);
                    } 
                    dispatch(updateStudent({
                        "lessonsProgram": newLessons
                    }))
           }
        }, [student.englishLevel, levels])
     */
    return (
        <PersonalDefaultPage>
            <LoadingContainer isLoading={isLoading}>
                <ModalQuestionTwoAnswers
                    type="question"
                    h2={t("Урок открыт на другом устройстве")}
                    p={t("Чтобы открыть уроки здесь, нужно завершить предыдущую сессию. Закрыть уроки на другом устройстве и открыть здесь?")}
                    yesText={t("Открыть здесь")}
                    noText={t("Остаться там")}
                    isOpen={isShowModalToCloseLesson}
                    onClose={() => setIsShowModalToCloseLesson('')}
                    onAnswer={async (answer) => {
                        if (answer) {
                            // Закрыть урок на другом устройстве
                            let uuid = await localStorage.getItem("uid");
                            if (!uuid) {
                                uuid = uuidv4()
                                await localStorage.setItem("uid", uuid)
                            }
                            let openHere = await axios.post(Config.BACKEND_ADDR + "/devices/set_close_lesson", { device_id: uuid });
                            if (openHere.status === 200) {
                                console.log("Lesson closed on other device, opening here");
                                // Открыть здесь
                                const win = window.open(isShowModalToCloseLesson, "_blank", "noopener,noreferrer");
                                if (win) win.opener = null;
                            }
                        }
                        setIsShowModalToCloseLesson('');
                    }}
                />
                {/*Update balance or lesson price*/}
                <ModalDefault
                    onRequestClose={() => setModalOpen(false)}
                    isOpen={modalOpen}
                    centerOnMobile={true}
                    centerAlways={true}
                >
                    <div style={{
                        width: 265,
                        //height: 245,
                        gap: 10,
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: "white",
                        borderRadius: 20,
                        padding: 20,
                        justifyContent: "space-evenly",
                        position: "relative",
                    }}>
                        <div style={{
                            position: "absolute",
                            top: 14,
                            right: 14,
                            cursor: "pointer",
                        }} onClick={() => setModalOpen(false)}>
                            <BsX style={{
                                fontSize: 30,
                                color: color_grey_dark
                            }} />
                        </div>
                        <div style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            // justifyContent: "space-between",
                            gap: 10
                        }}>
                            <div style={{
                                width: 30,
                                height: 30,
                                borderRadius: 10,
                                backgroundColor: changeData.changeIconColor,
                                display: "flex",
                                alignItems: "center",
                                alignContent: "center",
                                justifyContent: "center",
                            }}>
                                <img src={changeData.changeIcon} />
                            </div>
                            <OnestBoldDefault style={{ fontSize: 18 }}>
                                {changeData.changeText}
                            </OnestBoldDefault>
                        </div>
                        <div>
                            <div style={{
                                margin: 2,
                                paddingBottom: 5,
                                width: 305
                            }}><OnestNormalSmall>{t("Введите стоимость")}</OnestNormalSmall></div>
                            <input
                                style={{
                                    width: 265 - 15,
                                    height: 50,
                                    borderRadius: 10,
                                    paddingLeft: 15,
                                    color: color_grey_dark,
                                    backgroundColor: color_grey_ultra_light,
                                    border: "0px solid grey"
                                }}
                                inputMode="numeric"
                                value={`$${changeData.changeValue ?? ""}`}
                                onChange={(e) => {
                                    const allowNegative =
                                        changeData.changeType === "balance";
                                    const changeValue = normalizeMoneyInput(
                                        e.target.value,
                                        allowNegative,
                                    );
                                    setChangeData({
                                        ...changeData,
                                        changeValue,
                                    });
                                    setIsSaveButtonDisabled(
                                        !isValidMoneyValue(
                                            changeValue,
                                            allowNegative,
                                        ),
                                    );
                                }}

                            />
                        </div>

                        <div
                            onClick={async () => {
                                if (student.studentId === -1) {
                                    alert(t("Сначала заполните профиль и сохраните его!"))
                                    return
                                }
                                const allowNegative =
                                    changeData.changeType === "balance";
                                if (
                                    isSaveButtonDisabled ||
                                    !isValidMoneyValue(
                                        changeData.changeValue,
                                        allowNegative,
                                    )
                                ) {
                                    return;
                                }
                                const numericValue = Number(changeData.changeValue);
                                const data = {
                                    student_id: student.studentId,
                                    teacher_id: user.id
                                }
                                data[changeData.changeType] = numericValue
                                try {
                                    await axios.patch(
                                        config.BACKEND_ADDR + "/students/",
                                        data,
                                    );
                                    setIsSaveButtonDisabled(true)
                                    const studentUpdate = {}
                                    // TODO: убрать реплейс, разные названия на бэкенде и на фронте
                                    studentUpdate[
                                        changeData.changeType.replace(
                                            "lesson_cost",
                                            "lessonPrice",
                                        )
                                    ] = numericValue
                                    dispatch(updateStudent(studentUpdate))
                                    setModalOpen(false)
                                } catch (err) {
                                    console.log(err)
                                    alert(t("Ошибка обновления данных ученика"))
                                }
                            }}
                        >
                            <ButtonDefault
                                width={265}
                                height={40}
                                backgroundColor={isSaveButtonDisabled ? color_grey_light : color_red_default}
                                disabled={isSaveButtonDisabled}
                            >{t("Сохранить")}</ButtonDefault>
                        </div>
                    </div>
                </ModalDefault>
                <div style={{
                    //marginTop: screenWidth > TABLET_WINDOW_WIDTH && screenWidth < 1400 ? -43 : 0,
                    //marginLeft: screenWidth > TABLET_WINDOW_WIDTH && screenWidth < 1400 ? -15 : 0,
                    display: "flex",
                    flexDirection: isDesktop ? "row" : "column-reverse",
                    alignItems: isDesktop ? "flex-start" : "center",
                    gap: 20,
                    width: isDesktop
                        ? (isWideDesktop ? "100%" : "min(1120px, calc(100vw - 48px))")
                        : "100%",
                    maxWidth: isWideDesktop ? "none" : undefined,
                    margin: isDesktop ? "0 auto" : undefined,
                    justifyContent: isWideDesktop ? "space-between" : undefined,
                }}>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        width: isDesktop ? (isWideDesktop ? "auto" : 600) : mobileContentWidth,
                        flex: isDesktop && isWideDesktop ? "1 1 0%" : "0 0 auto",
                        minWidth: isDesktop ? 600 : undefined,
                        gap: 20
                    }}>
                        <div style={{
                            width: "100%",
                            boxSizing: "border-box",
                            // height: 225,
                            display: "flex",
                            flexDirection: screenWidth <= 430 ? "column" : "row",
                            flexWrap: screenWidth <= 430 ? "nowrap" : "wrap",
                            gap: 10,
                            padding: 20,
                            backgroundColor: color_white,
                            borderRadius: 20,
                            justifyContent: screenWidth <= 430 ? "flex-start" : "space-around",
                            alignItems: screenWidth <= 430 ? "stretch" : "center",
                        }}>
                            <IconInfoBigBlock
                                icon={dollar}
                                title={t("Стоимость занятия")}
                                addCharToValue={"$"}
                                text={student.lessonPrice}
                                backgroundColor={"#EAF1FF"}
                                iconBackgroundColor={"#8DB3FF"}
                                onClick={() => {
                                    setChangeData(Object.assign(changeData, {
                                        changeIcon: dollar,
                                        changeIconColor: "#8DB3FF",
                                        changeText: t("Стоимость занятия"),
                                        changeValue: student.lessonPrice,
                                        changeType: "lesson_cost"
                                    }))
                                    if (student.studentId === -1) {
                                        alert(t("Сначала заполните профиль и сохраните его!"))
                                        return
                                    }
                                    setIsSaveButtonDisabled(true)
                                    setModalOpen(true)
                                }}
                            />
                            <IconInfoBigBlock
                                icon={pig}
                                title={t("Баланс ученика")}
                                addCharToValue={"$"}
                                text={student.balance}
                                backgroundColor={"#FFE3F0"}
                                iconBackgroundColor={"#FF73B3"}
                                onClick={() => {
                                    if (student.studentId === -1) {
                                        alert(t("Сначала заполните профиль и сохраните его!"))
                                        return
                                    }
                                    setChangeData(Object.assign(changeData, {
                                        changeIcon: pig,
                                        changeIconColor: "#FF73B3",
                                        changeText: t("Баланс ученика"),
                                        changeValue: student.balance,
                                        changeType: "balance"
                                    }))
                                    setIsSaveButtonDisabled(true)
                                    setModalOpen(true)
                                }}
                            />
                            <IconInfoBigBlock
                                icon={agreeGreen}
                                title={t("Оплачено занятий")}
                                text={getPaidLessonsCount(
                                    student.balance,
                                    student.lessonPrice,
                                )}
                                backgroundColor={"#DBFFEE"}
                                iconBackgroundColor={"#9AF0C6"}
                            />
                        </div>
                        <StudentSchedule />
                        <StudentLessonsProgram levels={levels} openInNewWindow={openInNewWindow} />
                    </div>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        width: isDesktop ? (isWideDesktop ? "clamp(380px, 26vw, 460px)" : 480) : mobileContentWidth,
                        flex: "0 0 auto",
                        gap: 20
                    }}>
                        <StudentInfo levels={levels} />
                    </div>
                </div>
            </LoadingContainer>
        </PersonalDefaultPage>
    )
}